module.exports = "precision highp float;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nuniform sampler2D texture;\nuniform float opacity;\n\nvoid main(void) {\n\tvec4 color = texture2D(texture, vUv);\n\tgl_FragColor = vec4(color.rgb, opacity);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/scene/Shader/base.frag
// module id = Uczm
// module chunks = 1